module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mh4"
  }, [_c('div', {
    staticClass: "row mt4 ph4 flex items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 pa3 flex justify-end topics"
  }, [_c('div', {
    staticClass: "flex justify-center items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('pl-button', {
    staticClass: "pl-white b",
    staticStyle: {
      "font-size": "18px",
      "margin": "0px",
      "padding": "0px",
      "width": "fit-content"
    }
  }, [_c('label', {
    class: [_vm.showFile ? 'disable_upload' : ''],
    staticStyle: {
      "cursor": "pointer",
      "display": "block",
      "width": "100%",
      "height": "100%",
      "padding": "5px"
    },
    attrs: {
      "for": "files"
    }
  }, [_vm._v("Upload CSV File")])]), _vm._v(" "), (_vm.showFile) ? _c('div', {
    staticClass: "relative flex justify-center items-center",
    staticStyle: {
      "background-color": "#dfe8f2",
      "margin-top": "5px",
      "width": "170px",
      "max-height": "50px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": "/static/online_roundtable_icons/attach_file_icon.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-xs-9 truncate",
    staticStyle: {
      "color": "#3b24e3",
      "font-size": "18px",
      "font-weight": "400",
      "padding-left": "5px",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "100px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.file_name) + "\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close absolute",
    staticStyle: {
      "color": "#3b24e3",
      "font-size": "14px",
      "text-align": "right",
      "cursor": "pointer",
      "right": "2px",
      "top": "2px"
    },
    on: {
      "click": _vm.discardFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "topic-link primary b",
    staticStyle: {
      "text-decoration": "none",
      "font-size": "14px",
      "text-align": "center"
    },
    attrs: {
      "href": "../../../../static/upload_csv_files/users.csv",
      "target": "_blank",
      "download": "users.csv"
    }
  }, [_vm._v("\n          Download Template")])], 1), _vm._v(" "), _c('input', {
    ref: "fileUploader",
    staticStyle: {
      "visibility": "hidden",
      "width": "10px"
    },
    attrs: {
      "id": "files",
      "type": "file",
      "accept": ".csv",
      "disabled": _vm.showFile
    },
    on: {
      "click": _vm.resetFileUploader,
      "change": function($event) {
        return _vm.handleFiles($event)
      }
    }
  }), _vm._v(" "), (_vm.csv_has_errors) ? _c('div', _vm._l((_vm.csv_error_message), function(error) {
    return _c('div', {
      key: error
    }, [_c('p', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(error))])])
  }), 0) : _vm._e()])]), _vm._v(" "), (!_vm.showFile && _vm.handlingFile) ? _c('div', {
    staticClass: "mh2 middle-xs between-xs mb-7"
  }, [_c('pl-spinner', {
    staticClass: "x3",
    staticStyle: {
      "margin": "auto"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mh2 middle-xs between-xs mb-7"
  }, [_c('vue-table', {
    staticClass: "pt5",
    attrs: {
      "tbody-data": _vm.usersToCheck,
      "headers": _vm.headers,
      "custom-options": _vm.customOptions,
      "style-wrap-vue-table": _vm.styleWrapVueTable,
      "disable-cells": _vm.disableCells,
      "disable-sort-thead": _vm.disableSortThead,
      "loading": _vm.loading,
      "parent-scroll-element": _vm.parentScrollElement,
      "select-position": _vm.selectPosition,
      "submenu-thead": _vm.submenuThead
    },
    on: {
      "tbody-checked-row": _vm.checkedData,
      "tbody-all-checked-row": _vm.checkedAllData,
      "tbody-change-data": _vm.checkErrorsInTable
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.errors_count > 0) ? _c('div', {
    staticClass: "fw6",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n          You have "), _c('label', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.errors_count))]), _vm._v(" errors. Fix\n          them before proceeding.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canImport) ? _c('div', [_c('span', {
    staticClass: "fw6"
  }, [_vm._v("You don't have any errors in your file, you can proceed to add\n            new users.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 flex items-center justify-center tc pt4"
  }, [_c('pl-checkbox', {
    on: {
      "change": function($event) {
        return _vm.handleSelect($event)
      }
    },
    model: {
      value: (_vm.send_email),
      callback: function($$v) {
        _vm.send_email = $$v
      },
      expression: "send_email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-caption na1"
  }, [_vm._v("Send email notifications to teachers.")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tr pr1 remove_btn",
    class: [
      _vm.usersToRemove.length === 0 ? 'disable_remove' : 'remove_btn' ]
  }, [_c('span', {
    on: {
      "click": _vm.deleteUser
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Remove selected")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_vm._v("Loader")])]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary pl-icon",
    staticStyle: {
      "margin": "5px",
      "float": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addRow.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-9 warning-text"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "yellow-alert pr2"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2"
  }, [_vm._v("The email is already registered in the school, any new data will\n          update the existing information for this user.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "red-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2"
  }, [_vm._v("The field should not be empty.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2 text-red"
  }, [_vm._v("The email is not valid.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pl2 text-orange"
  }, [_vm._v("The role should be teacher or student.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6f4caf32!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalUsers/addUsers/addUsersSecondStep.vue
// module id = 2067
// module chunks = 61